import { connect } from 'react-redux';
import copy from 'copy-to-clipboard';
import { currentEpisodeActions } from '../../../../actions';
import { goToLoginWithAction, isLogged, onFB } from '../../helpers';
import SocialActions from '../../../design/LastPage/SocialActions';

const mapState = state => ({
  liked: state.currentEpisode.liked,
  onFB: onFB(state.story.public_url)
});


const mapDispatch = (dispatch, ownProps) => {
  const { story } = ownProps;
  const episodeTitle = ownProps.currentEpisode.title;
  const storyUrl = (I18n.locale !== 'en'
    ? story.public_url && story.public_url.replace('story/', `${I18n.locale}/story/`)
    : story.public_url
  );
  const twitterUrl = `https://twitter.com/intent/tweet?lang=${I18n.locale}&text=${
    I18n.t('components.episode_last_page.social_actions.twitter.text', { title: episodeTitle, by: story.title })
  }${storyUrl}`;

  return {
    onLike: (event) => {
      event.preventDefault();
      isLogged()
        ? dispatch(currentEpisodeActions.episodeToggleLike(ownProps.currentEpisode.id))
        : goToLoginWithAction('popcomics-webreader-like-episode', ownProps.currentEpisode.id);
    },

    onTwitter: (event) => {
      event.preventDefault();
      window.open(twitterUrl, '_blank', 'width=550,height=450,modal=yes,alwaysRaised=yes');
    },

    onCopyLink: (event) => {
      event.preventDefault();
      copy(document.location.href);
      setNoticeSuccess(ownProps.linkCopied);
    }
  };
};

export default connect(mapState, mapDispatch)(SocialActions);

